import * as type from "../action-types";

type load = { id: string }

export const getProjectCategoriesAction = (payload?: load) => ({
    type: type.GET_PROJECT_CATEGORIES
});
